document.addEventListener('DOMContentLoaded', function () {
  (function() {
    const sections = document.querySelectorAll('.shopby-mood');

    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const buttons = section.querySelectorAll('.shopby-mood__filter');
      const items = section.querySelectorAll('.shopby-mood__item');
      const emptyState = section.querySelector('[data-empty-state]');
      const visibleCountEl = section.querySelector('[data-visible-count]');
      const paramName = 'mood';

      const normalise = (value) =>
        (value || '')
          .toString()
          .trim()
          .toLowerCase();

      const getSelectedMoodFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return normalise(params.get(paramName));
      };

      const updateUrl = (selectedMood) => {
        const url = new URL(window.location.href);

        if (selectedMood) {
          url.searchParams.set(paramName, selectedMood);
        } else {
          url.searchParams.delete(paramName);
        }

        window.history.replaceState({}, '', url.toString());
      };

      const setActiveButton = (selectedMood) => {
        buttons.forEach((button) => {
          const buttonMood = normalise(button.dataset.mood);
          const isActive = buttonMood === selectedMood || (!selectedMood && buttonMood === '');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const filterProducts = (selectedMood) => {
        let visibleCount = 0;

        items.forEach((item) => {
          const itemMoods = normalise(item.dataset.moods)
            .split(',')
            .map((value) => normalise(value))
            .filter(Boolean);

          const shouldShow = !selectedMood || itemMoods.includes(selectedMood);

          item.classList.toggle('hidden', !shouldShow);

          if (shouldShow) visibleCount += 1;
        });

        if (visibleCountEl) visibleCountEl.textContent = visibleCount;

        if (emptyState) {
          emptyState.classList.toggle('hidden', visibleCount > 0);
        }

        setActiveButton(selectedMood);
      };

      const applyMood = (selectedMood, updateBrowserUrl = true) => {
        filterProducts(selectedMood);

        if (updateBrowserUrl) {
          updateUrl(selectedMood);
        }

        const activeButton = Array.from(buttons).find(
          (btn) => (btn.dataset.mood || '') === selectedMood
        );

        const colour = activeButton ? activeButton.dataset.colour : null;

        if (colour) {
          section.style.backgroundColor = colour;
        } else {
          section.style.backgroundColor = '';
        }

        document.dispatchEvent(new CustomEvent('shopbymood:change', {
          detail: { mood: selectedMood }
        }));
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const selectedMood = normalise(button.dataset.mood);
          applyMood(selectedMood, true);
        });
      });

      applyMood(getSelectedMoodFromUrl(), false);
    });
  })();
});